<script>
export default {
  name: 'AiGeneratedNote',
  props: {
    texto: {
      type: String,
      default: '',
    },
    rotulo: {
      type: String,
      default: 'Gerado por IA',
    },
    limite: {
      type: Number,
      default: 220,
    },
  },
  data() {
    return {
      expandido: false,
    }
  },
  computed: {
    temTexto() {
      return !!(this.texto && this.texto.trim())
    },
    precisaTruncar() {
      return this.temTexto && this.texto.length > this.limite
    },
    textoVisivel() {
      if (!this.precisaTruncar || this.expandido) return this.texto
      return `${this.texto.slice(0, this.limite).trimEnd()}…`
    },
    toggleLabel() {
      return this.expandido ? 'Mostrar menos' : 'Mostrar mais'
    },
  },
  methods: {
    alternar() {
      this.expandido = !this.expandido
    },
  },
}
</script>

<template>
  <div v-if="temTexto" class="ai-generated-note">
    <div class="d-flex align-center az-gap-xsmall mb-1">
      <icon-svg name="stars" :size="16" />
      <span class="text-sm font-medium">{{ rotulo }}</span>
    </div>
    <!-- O toggle vive NO FIM do texto, no fluxo do paragrafo (padrao de "ler mais" do mercado),
         e nao como botao em bloco embaixo: em bloco ele rouba a hierarquia da acao real do modal. -->
    <p class="text-sm text-color-900 mb-0">
      {{ textoVisivel }}
      <button
        v-if="precisaTruncar"
        type="button"
        class="ai-generated-note__toggle text-xs text-color-600"
        @click="alternar"
      >
        {{ toggleLabel }}</button>
    </p>
    <slot name="rodape" />
  </div>
</template>

<style lang="sass" scoped>
.ai-generated-note
  border: 1px solid var(--border-hairline)
  background: var(--neutral-50)
  border-radius: 8px
  padding: 16px

// Tamanho e cor saem das utilitarias (`text-xs text-color-600`), como o resto do modulo faz —
// nada de hex nem de `var(--...)` que nao existe. Aqui fica so o que e do BOTAO: tirar a aparencia
// de botao e separar do reticencias, que sem a margem encostava no rotulo.
// Sem margem: o respiro vem de um ESPACO DE TEXTO entre o paragrafo e o botao. Espaco colapsa no
// inicio da linha e sobrevive no meio dela — margem faz o contrario, vira recuo quando o toggle
// cai pra linha seguinte (truncado) e some quando ele fica colado no fim do texto (expandido).
.ai-generated-note__toggle
  background: none
  border: 0
  padding: 0
  font-family: inherit
  text-decoration: underline
  cursor: pointer

  &:hover
    opacity: .75
</style>
